module.exports = __webpack_public_path__ + "static/media/yourbodyshow-logo.65f21804.jpg";